import { type FunctionComponent } from 'react';

import BackendConfig from './BackendConfig';
import ContractCustomization from './ContractCustomization';
import FrontendConfig from './FrontendConfig';
import GeneralInformation from './GeneralInformation';
import ResetExecutions from './ResetExecutions';
import RuleSetWithId from './RulesetWithIds';
import UuidHexConverter from './UuidHexConverter';
import { type AppLicense } from '../../license/AppLicense';

import './AdminPage.style.sass';
import '../../App.style.sass'; // Keep the application's Blueprint style overrides on the admin page.

interface AdminPageProps {
  changeUserRole: (role: any) => void;
  changeLicense: (license: AppLicense) => void;
}

export const AdminPage: FunctionComponent<AdminPageProps> = (props: AdminPageProps) => {
  return (
    <div className="admin-page">
      <h1>Configuration</h1>
      <div className="flex-container">
        <BackendConfig />
        <FrontendConfig changeUserRole={props.changeUserRole} changeLicense={props.changeLicense} />
      </div>
      <h1 className="section">Miscellaneous</h1>
      <div className="flex-container">
        <GeneralInformation />
        <ContractCustomization />
        <RuleSetWithId />
        <UuidHexConverter />
        <ResetExecutions />
      </div>
    </div>
  );
};

export default AdminPage;
